import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import BackToTop from '../components/backToTop/BackToTop';
import Quote from '../components/quote/Quote';
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { getOpeningHours } from "../functions/OperatingHours";
import { useIsMobile } from "../functions/Theme";
import AdQuestions from '../functions/AdQuestions';

export default function NoQuotes(props: any) {
    const [customerDetails, setCustomerDetails] = useState<CustomerDetails>(JSON.parse(localStorage.getItem('customerDetails') || ""));
    const openingHours = getOpeningHours()
    const standardHours = openingHours.Monday.open + " - " + openingHours.Thursday.close;
    const fridayHours = openingHours.Friday.open + " - " + openingHours.Friday.close;
    const config = JSON.parse(localStorage.getItem('siteConfig') || "{}");
    const navigate = useNavigate();

    let pageNo: number = 4;

    if (localStorage.getItem('shortJourney') === "true") {
        pageNo = 3;
    }

    props.setSidebarVisibility(false);

    useEffect(() => {
        setCustomerDetails(JSON.parse(localStorage.getItem('customerDetails') || ""));
        props.setCurrentPage(pageNo);
    }, [])

    const backNavigation = () => {
        navigate("/YourBusiness");
    }

    return (
        <>
            
                <div className="results-form-header">
                    <div className="form-title">
                        <h1>Your quotes</h1>
                    </div>
            </div>
            <div className="noquotes-container">
                <div className="filter-sort">
                    <AdQuestions />
                </div>
                <div className="no-quotes">
                    <p>Unfortunately we were unable to provide an online quote at this time.</p>
                    <p>We will contact you shortly as we have alternative options we would like to discuss with you.</p>
                    <p>If you prefer, you can call us on {config.phoneNumber}</p>
                    <p>Your Reference Number is: {customerDetails.policyNumber}</p>
                    <p>Mon-Thurs {standardHours}</p>
                    <p>Friday {fridayHours}</p>
                
                    {localStorage.getItem("questions") != null &&
                        <div className="btn-container btn-container-update-details" style={{ paddingLeft: 0 }}>
                        <button className="btn back update-details" style={{ marginRight: 'auto', maxWidth: 200}} onClick={() => backNavigation()}>
                            Edit quote details
                        </button>
                    </div>
                    }
                </div>
            </div>

        </>
    )
}